var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnalysisBro(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-72"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "134.22 65.28 42.59 65.28 41.38 80.07 134.22 80.07 134.22 65.28",
    style: {
      fill: "none",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.22 80.07 42.59 80.07 41.38 94.87 134.22 94.87 134.22 80.07",
    style: {
      fill: "none",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.22 94.87 42.59 94.87 41.38 109.67 134.22 109.67 134.22 94.87",
    style: {
      fill: "none",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.22 109.67 42.59 109.67 41.38 124.47 134.22 124.47 134.22 109.67",
    style: {
      fill: "none",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.22 124.47 42.59 124.47 41.38 139.26 134.22 139.26 134.22 124.47",
    style: {
      fill: "none",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.22 139.26 42.59 139.26 41.38 154.06 134.22 154.06 134.22 139.26",
    style: {
      fill: "none",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.22 154.06 42.59 154.06 41.38 168.86 134.22 168.86 134.22 154.06",
    style: {
      fill: "none",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.22 168.86 42.59 168.86 41.38 183.65 134.22 183.65 134.22 168.86",
    style: {
      fill: "none",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.22 183.65 42.59 183.65 41.38 198.45 134.22 198.45 134.22 183.65",
    style: {
      fill: "none",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.22 198.45 42.59 198.45 41.38 213.25 134.22 213.25 134.22 198.45",
    style: {
      fill: "none",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.22 213.25 42.59 213.25 41.38 228.04 134.22 228.04 134.22 213.25",
    style: {
      fill: "none",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.22 228.04 42.59 228.04 41.38 242.84 134.22 242.84 134.22 228.04",
    style: {
      fill: "none",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.22 242.84 42.59 242.84 41.38 257.64 134.22 257.64 134.22 242.84",
    style: {
      fill: "none",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.22 257.64 42.59 257.64 41.38 272.44 134.22 272.44 134.22 257.64",
    style: {
      fill: "none",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.22 272.44 42.59 272.44 41.38 287.23 134.22 287.23 134.22 272.44",
    style: {
      fill: "none",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.4 65.28 136.78 65.28 135.57 80.07 228.4 80.07 228.4 65.28",
    style: {
      fill: "none",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.4 80.07 136.78 80.07 135.57 94.87 228.4 94.87 228.4 80.07",
    style: {
      fill: "none",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.4 94.87 136.78 94.87 135.57 109.67 228.4 109.67 228.4 94.87",
    style: {
      fill: "none",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.4 109.67 136.78 109.67 135.57 124.47 228.4 124.47 228.4 109.67",
    style: {
      fill: "none",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.4 124.47 136.78 124.47 135.57 139.26 228.4 139.26 228.4 124.47",
    style: {
      fill: "none",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.4 139.26 136.78 139.26 135.57 154.06 228.4 154.06 228.4 139.26",
    style: {
      fill: "none",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.4 154.06 136.78 154.06 135.57 168.86 228.4 168.86 228.4 154.06",
    style: {
      fill: "none",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.4 168.86 136.78 168.86 135.57 183.65 228.4 183.65 228.4 168.86",
    style: {
      fill: "none",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.4 183.65 136.78 183.65 135.57 198.45 228.4 198.45 228.4 183.65",
    style: {
      fill: "none",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.4 198.45 136.78 198.45 135.57 213.25 228.4 213.25 228.4 198.45",
    style: {
      fill: "none",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.4 213.25 136.78 213.25 135.57 228.04 228.4 228.04 228.4 213.25",
    style: {
      fill: "none",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.4 228.04 136.78 228.04 135.57 242.84 228.4 242.84 228.4 228.04",
    style: {
      fill: "none",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.4 242.84 136.78 242.84 135.57 257.64 228.4 257.64 228.4 242.84",
    style: {
      fill: "none",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.4 257.64 136.78 257.64 135.57 272.44 228.4 272.44 228.4 257.64",
    style: {
      fill: "none",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.4 272.44 136.78 272.44 135.57 287.23 228.4 287.23 228.4 272.44",
    style: {
      fill: "none",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.24,
    y: 53.82,
    width: 193.75,
    height: 11.16,
    style: {
      fill: "none",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.99,
    y1: 64.98,
    x2: 232.99,
    y2: 261.57,
    style: {
      fill: "none",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 230.88,
    y1: 65.3,
    x2: 230.88,
    y2: 200.18,
    style: {
      fill: "none",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.76,
    y: 261.14,
    width: 2.6,
    height: 5.01,
    style: {
      fill: "#263238",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.41,
    y: 199.1,
    width: 2.6,
    height: 5.01,
    style: {
      fill: "#263238",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Picture--inject-72"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 577,
    y: 65,
    width: 118,
    height: 140,
    style: {
      fill: "none",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 582.9,
    y: 72,
    width: 106.2,
    height: 126,
    style: {
      fill: "none",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 611.56,
    y: 106,
    width: 48.89,
    height: 58,
    style: {
      fill: "none",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-72"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "118.93 446.49 118.93 359.35 655.47 359.35 656.18 451.47 640.85 448.41 641 383 135 383 135.03 445.73 118.93 446.49",
    style: {
      fill: "#e3e3e3"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "119 452.31 119 351 656 351 656 454.79",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.05,
    y: 359.35,
    width: 536.42,
    height: 8.18,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "135 451.31 135 383 641 383 641 455.79",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.35,
    y: 346.33,
    width: 563.58,
    height: 13.1,
    style: {
      fill: "#ccc",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "663.93 346.28 100.35 346.28 142.62 287.58 621.66 287.58 663.93 346.28",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--device-3--inject-72"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M600.33,283l8.82,10.93a5.78,5.78,0,0,1-.94,8.18L587.83,318l-45-16,19.74-12.24a5.77,5.77,0,0,0,1.65-8.28L558.83,274Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "504.33 122.59 688.83 152.5 688.83 305 683.33 306.5 498.83 264.09 498.83 124.09 504.33 122.59",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "498.83 264.09 683.33 306.5 683.33 154 498.83 124.09 498.83 264.09",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "503.83 261.03 678.33 301.56 678.33 157.06 503.83 129.03 503.83 261.03",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--device-2--inject-72"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "414.2 294.78 345.75 294.78 351.45 273.99 351.45 262.1 408.49 262.1 408.49 275.17 414.2 294.78",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.5,
    y: 124,
    width: 207.5,
    height: 140,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.5,
    y: 128,
    width: 197.5,
    height: 132,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--device-1--inject-72"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160,283l-8.82,10.93a5.78,5.78,0,0,0,.95,8.18L172.5,318l45-16-19.74-12.24a5.77,5.77,0,0,1-1.64-8.28L201.5,274Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256 122.59 71.5 152.5 71.5 305 77 306.5 261.5 264.09 261.5 124.09 256 122.59",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.5 264.09 77 306.5 77 154 261.5 124.09 261.5 264.09",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256.5 261.03 82 301.56 82 157.06 256.5 129.03 256.5 261.03",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--charts-3--inject-72"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 558.49,
    cy: 187.42,
    rx: 24.9,
    ry: 30.28,
    transform: "translate(18.87 423.75) rotate(-42.2)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574,184.09,563.47,182a38.58,38.58,0,0,0,1.36-7.13c.39-4-1-4.86-4.08-5.48s0,2.73-1.56,5.73c-1.25,2.41-5,4.32-6.42,5v18.28l15.57,3.05c5.25.25,1.94-4.09,1.94-4.09,3.9,0,1.56-4.37,1.56-4.37,3.9.18,1.17-4,1.17-4C577.1,187.81,574,184.09,574,184.09Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "541.87 195.7 550.63 197.42 550.63 179.7 541.87 177.99 541.87 195.7",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 624.25,
    cy: 200.31,
    rx: 24.9,
    ry: 30.28,
    transform: "translate(27.26 471.25) rotate(-42.2)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.75,203.64l10.52,2.06a39,39,0,0,0-1.37,7.13c-.39,4,1,4.86,4.09,5.47s0-2.72,1.56-5.73c1.24-2.4,5-4.31,6.42-5V189.31l-15.57-3.06c-5.26-.25-1.95,4.1-1.95,4.1-3.89,0-1.55,4.37-1.55,4.37-3.9-.18-1.17,4.05-1.17,4.05C605.64,199.92,608.75,203.64,608.75,203.64Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "640.87 192.03 632.11 190.31 632.11 208.02 640.87 209.74 640.87 192.03",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "520.44 251.25 543.64 236.91 557.55 248.38 582.74 225.43 592.02 251.97 603.28 244.8 611.9 254.12 637.08 241.21 651 281.38 520.44 251.25",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "520.44 251.25 539 244.08 558.22 254.84 580.09 241.21 592.68 258.43 603.28 252.69 611.9 258.43 633.77 250.53 651 281.38 520.44 251.25",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 544.11,
    y1: 149.39,
    x2: 575.68,
    y2: 154.41,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 610.83,
    y1: 159.43,
    x2: 642.39,
    y2: 164.45,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--charts-2--inject-72"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 299.4,
    y: 144.13,
    width: 48.06,
    height: 7.66,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.4,
    y: 158.07,
    width: 24.38,
    height: 4.18,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 389.15,
    cy: 174.59,
    r: 14.18,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398,176.65l-1.13,1.14-7.53,7.52-8.66-8.66a5.32,5.32,0,0,1,7.53-7.52l1.14,1.14,1.13-1.14a5.32,5.32,0,1,1,7.52,7.52Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 314.36,
    cy: 199.28,
    r: 14.18,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 314.36,
    cy: 199.28,
    r: 9.27,
    transform: "translate(-48.84 280.66) rotate(-45)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309,202.14a6.06,6.06,0,0,0,10.59.2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 311.46,
    cy: 197.56,
    rx: 0.7,
    ry: 1.92,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.39,197.56c0,1.06-.32,1.92-.7,1.92s-.7-.86-.7-1.92.31-1.91.7-1.91S317.39,196.51,317.39,197.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 428.03,
    cy: 150.88,
    r: 14.18,
    transform: "translate(142.81 503.9) rotate(-70.48)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 428.03,
    cy: 150.88,
    r: 9.27,
    transform: "translate(-18.68 70.72) rotate(-9.24)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.61,152.58c.63,2.34,2.23,4.37,5.42,4.37s4.84-1.84,5.43-4.37Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.83,149.17c0,1.06-.31,1.92-.7,1.92s-.7-.86-.7-1.92.32-1.92.7-1.92S425.83,148.11,425.83,149.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.06,149.17c0,1.06-.32,1.92-.7,1.92s-.7-.86-.7-1.92.31-1.92.7-1.92S431.06,148.11,431.06,149.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 352.11,
    cy: 188.43,
    r: 14.18,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 352.11,
    cy: 188.43,
    r: 9.27,
    transform: "translate(46.41 445.39) rotate(-68.2)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.75,194.5a6.07,6.07,0,0,1,10.6-.2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.9,186.71c0,1.06-.31,1.92-.7,1.92s-.69-.86-.69-1.92.31-1.91.69-1.91S349.9,185.66,349.9,186.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 354.43,
    cy: 186.71,
    rx: 0.7,
    ry: 1.92,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.8,
    y: 216.58,
    width: 25.58,
    height: 13.93,
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.17,
    y: 205.99,
    width: 25.58,
    height: 24.52,
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.54,
    y: 192.06,
    width: 25.58,
    height: 38.45,
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.92,
    y: 169.21,
    width: 25.58,
    height: 61.3,
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 457.65,
    cy: 176.31,
    r: 9.8,
    transform: "translate(9.37 375.24) rotate(-45)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.18,174h-3.75a16.23,16.23,0,0,0,.48-2.64c.14-1.46-.35-1.67-1.46-1.67s0,1-.55,2.16a7.17,7.17,0,0,1-2.3,2.23v6.52h5.56c1.88-.27.7-1.59.7-1.59,1.39-.28.55-1.67.55-1.67,1.39-.21.42-1.53.42-1.53A1,1,0,0,0,463.18,174Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 451.71,
    y: 174.1,
    width: 3.13,
    height: 6.32,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 457.65,
    cy: 219.25,
    r: 9.8,
    transform: "translate(-20.99 387.82) rotate(-45)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.12,221.53h3.75a15.59,15.59,0,0,0-.49,2.64c-.14,1.46.35,1.67,1.46,1.67s0-1,.56-2.16a7.15,7.15,0,0,1,2.29-2.23v-6.52h-5.56c-1.87.27-.69,1.59-.69,1.59-1.39.28-.56,1.67-.56,1.67-1.39.21-.42,1.53-.42,1.53A1,1,0,0,0,452.12,221.53Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 460.46,
    y: 215.13,
    width: 3.13,
    height: 6.32,
    transform: "translate(924.04 436.59) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--charts-1--inject-72"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.34,183.31,104.58,203.78c-2.75.54-5-.9-5-3.22V182c0-2.33,2.24-4.62,5-5.13l103.76-19c2.47-.45,4.46,1,4.46,3.15v17.54C212.8,180.65,210.81,182.82,208.34,183.31Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.2,186.14c0-4.65-4.44-7.6-9.94-6.57s-10.05,5.67-10.05,10.37,4.51,7.64,10.05,6.56S125.2,190.79,125.2,186.14Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 135.04,
    y1: 180.15,
    x2: 178.11,
    y2: 172.05,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 135.04,
    y1: 183.87,
    x2: 178.11,
    y2: 175.69,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 135.04,
    y1: 188.53,
    x2: 199.18,
    y2: 176.18,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.34,258.85,104.58,283.56c-2.75.66-5-.69-5-3V261.94c0-2.33,2.24-4.72,5-5.33l103.76-23.28c2.47-.55,4.46.78,4.46,3v17.53C212.8,256,210.81,258.27,208.34,258.85Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.2,265.08c0-4.65-4.44-7.41-9.94-6.16S105.21,265,105.21,269.7s4.51,7.45,10.05,6.15S125.2,269.74,125.2,265.08Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 135.04,
    y1: 258.69,
    x2: 178.11,
    y2: 248.83,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 135.04,
    y1: 262.41,
    x2: 178.11,
    y2: 252.47,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 135.04,
    y1: 267.07,
    x2: 199.18,
    y2: 252.1,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.14,161.6c0-4.83-4.38-7.94-9.82-6.95s-9.92,5.75-9.92,10.63,4.46,8,9.92,6.93S218.14,166.42,218.14,161.6Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.43,163.56l-.78.85-5.23,5.64-6-4.23c-1.45-1-1.45-3.12,0-4.68a4.87,4.87,0,0,1,2.64-1.45,3.48,3.48,0,0,1,2.62.48l.79.56.79-.85a4.77,4.77,0,0,1,2.61-1.44,3.38,3.38,0,0,1,2.6.48C215.87,159.93,215.87,162,214.43,163.56Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.51,214.59l-100.88,21.9c-2.67.58-4.85-.8-4.85-3.09V215.05c0-2.29,2.18-4.59,4.85-5.13l100.88-20.51c2.39-.49,4.33.87,4.33,3v17.29A5.45,5.45,0,0,1,233.51,214.59Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.66,218.76c0-4.58-4.31-7.41-9.66-6.31s-9.76,5.76-9.76,10.39,4.39,7.45,9.76,6.3S152.66,223.35,152.66,218.76Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 162.23,
    y1: 212.69,
    x2: 204.1,
    y2: 203.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 162.23,
    y1: 216.36,
    x2: 204.1,
    y2: 207.57,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 162.23,
    y1: 220.95,
    x2: 224.59,
    y2: 207.71,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.87,192.94c0-4.76-4.27-7.76-9.56-6.69s-9.67,5.85-9.67,10.66,4.34,7.8,9.67,6.68S241.87,197.71,241.87,192.94Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.57,193.62c0-3.12-2.8-5.08-6.26-4.37s-6.31,3.83-6.31,7,2.83,5.09,6.31,4.36S238.57,196.74,238.57,193.62Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.62,196.72c.43,1.34,1.52,2.36,3.69,1.91A4.41,4.41,0,0,0,236,195.2Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.81,194.18c0,.64-.21,1.21-.47,1.27s-.47-.43-.47-1.08.21-1.22.47-1.27S230.81,193.53,230.81,194.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.36,193.45c0,.64-.22,1.21-.48,1.27s-.47-.43-.47-1.08.21-1.21.47-1.27S234.36,192.8,234.36,193.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219,233.69c0-4.82-4.38-7.76-9.81-6.56s-9.91,6.14-9.91,11,4.45,7.8,9.91,6.54S219,238.52,219,233.69Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.62,234.46c0-3.16-2.87-5.08-6.43-4.29s-6.47,4-6.47,7.2,2.91,5.1,6.47,4.28S215.62,237.62,215.62,234.46Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.47,240.52a5.76,5.76,0,0,1,3.72-2.84,3.5,3.5,0,0,1,3.64,1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.66,235.19c0,.66-.22,1.24-.49,1.3s-.48-.42-.48-1.08.22-1.23.48-1.29S207.66,234.54,207.66,235.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.29,234.38c0,.65-.21,1.23-.48,1.29s-.48-.42-.48-1.08.21-1.23.48-1.29S211.29,233.72,211.29,234.38Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-72"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350.76,268.46s-2.54-2.82-5.65-2.54-3.39,0-1.69,7.9,4.8,15,6.49,15a4,4,0,0,0,2.82-1.41l2.54,5.36h61s9-15.8,7.9-23.42-7.34-2.54-7.34-2.54Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.48,284s-6.77-4-9.88-10.72a28.53,28.53,0,0,1-2.82-12.14s-7.06-9-1.41-23.14,9.31-17.5,11.57-16.94l2.26.57s7.34-16.09,18.63-16.09,26.53,8.18,34.15,16.65,11.57,22,9.88,24.84a8.7,8.7,0,0,1-4.23,3.67s-.57,15-5.37,21.45a126.44,126.44,0,0,1-10.72,12.42L362.89,286Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267,317.32s2-7,1-12-5.5-13.5-2.5-20,6.33-5.64,4.5-1.5c-1.19,2.7-.5,7-.5,7s4.5-6,6.5-6.5a18.78,18.78,0,0,1,5.5,0s1.5-2.5,3-2.5h5s5.5-6.5,8.5-5,9,8,7.5,11-5.5-1.5-5.5-1.5l-2-2.5s-2.5,5.5-3,9.5a18.16,18.16,0,0,0,0,6l2,1.5,9-3c3-1,6.5,2.5,4,4s-8.5,5-9.5,6.5-6,3-6,3l-3.5,1-7,13S272,313.32,267,317.32Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.5,281.82s-2.5,1.5-3.5,6",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.5,284.32a19.59,19.59,0,0,0-4,4.5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284,318.82s-5-6.5-11-7-9,1-10,3-4,4-4,4-15.5,10.5-23,18-16,14-15.5,21,15.5,9,20.5,6.5,13.5-11.5,17-17.5S284,318.82,284,318.82Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.5,298.32s-18-13.5-31.5-18.5-30.5-2-40,3.5-23,14-23,14Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.5,334.32s-2-7-1-12,5.5-13.5,2.5-20-6.6-5.51-4.5-1.5a9.32,9.32,0,0,1,.5,7s-4.5-6-6.5-6.5a18.78,18.78,0,0,0-5.5,0s-1.5-2.5-3-2.5h-5s-5.5-6.5-8.5-5-9,8-7.5,11,5.5-1.5,5.5-1.5l2-2.5s2.5,5.5,3,9.5a18.16,18.16,0,0,1,0,6l-2,1.5-9-3c-3-1-6.5,2.5-4,4s8.5,5,9.5,6.5,6,3,6,3l3.5,1,7,13S502.5,330.32,507.5,334.32Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485,298.82s2.5,1.5,3.5,6",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493,301.32a19.59,19.59,0,0,1,4,4.5",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494,336.32s1-2.5,5.5-4.5,10,0,10,0l3,6.5s-3,2.5,8.5,9.5,16,20.5,16,26.5-16.5-8-26.5-16S494,336.32,494,336.32Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.5,298.82s-29.5-8-48-9-44,5.5-47.5,6-33,4.5-36,6-55,41.5-55,41.5-8,1.5-18,4.5-12,11-12,11,3,23,10,26,13,0,19-2.5,51.5-18,51.5-18l6.5,37.5H450.5l9-39.5s52,40,59.5,40.5,17.5-4.5,21.5-12-5.5-24-9-29-13.5-10.5-21-15.5-37.5-38.5-41.5-41.5S432.5,298.82,432.5,298.82Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.53,329.87s15.47-19.87-3.74-20a51.55,51.55,0,0,0-31.73,10.62s-46.62-10.62-69.91-10.62S360.9,320.48,367,331s-27.46-10.52-41.38-12.65c-10.12-1.55-14.2,4-15.37,16.17l-18-11.91S252,364,247,366s-16-6-16,3,10,15.65,14,13.32S294,361,294,361l16,32,4.76,1.7c.15.84.24,1.3.24,1.3l3.81.15L324,398l0-1.66L446,401l10-40s41,22,49,29,16,4,19-1S460.53,329.87,460.53,329.87Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.73,317.91c1.82,1,3.3,1.79,4.27,2.41",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364,300.82s20.56,9.35,32.67,15.5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.5,310.32s14,6,20.5,11.5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "466.19 339.25 459.5 362.32 473.5 337.32",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 469.5,
    y1: 327.82,
    x2: 467.84,
    y2: 333.55,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "290.64 339.42 296.5 364.32 282.5 342.82",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 288.5,
    y1: 330.32,
    x2: 289.62,
    y2: 335.09,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.75,351.68A42.6,42.6,0,0,1,246,343.32",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.5,357.82a35.63,35.63,0,0,1,3.08-3.33",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.24,453.32l-11.93-59.91a5.51,5.51,0,0,1,5.41-6.59H459.78a5.51,5.51,0,0,1,5.41,6.59l-11.93,59.91",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "309.61 453.32 297.5 386.82 459 386.82 446.89 453.32",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalysisBro);
export default __webpack_public_path__ + "static/media/analysis-bro.a9406bcb56ba266381f59fba3b9a9bf7.svg";
export { ForwardRef as ReactComponent };